import {
  addToCart,
  clearCart,
  removeFromCart,
} from "@/pages/cart-management/cart-management.slice";
import { setSelectedTableItems } from "@/pages/shared/shared.reducer";

export const createDashboardCartActions = (dispatch) => ({
  emptyCart(updateTotalDocumentCount, refetch) {
    dispatch(clearCart({ cardDocumentsName: "dashboardCartDocumentIds" }));
    dispatch(setSelectedTableItems("cartManagementTable", [], []));
    updateTotalDocumentCount();
    refetch();
  },
  addToCart(documentIdsToAdd) {
    dispatch(
      addToCart({
        cardDocumentsName: "dashboardCartDocumentIds",
        ids: documentIdsToAdd,
      })
    );
  },
  deleteFromCart(documentIdsToRemove) {
    dispatch(
      removeFromCart({
        cardDocumentsName: "dashboardCartDocumentIds",
        ids: documentIdsToRemove,
      })
    );
    dispatch(setSelectedTableItems("cartManagementTable", [], []));
  },
});